import { combineReducers } from 'redux'
import { reducer as reduxForm } from 'redux-form'
import content from '../modules/content/reducer'
import social from './social'
import environment from './environmentReducer'
// import mailinglist from '../modules/mailinglist/reducer';
import reservation from '../modules/reservation/reducer'
import booking from '../modules/booking/reducer'
import calendar from '../modules/calendar/reducer'
import compare from '../modules/compare/reducer'

import entities from './entityReducer'
import preferences from './preferenceReducer'
import filters from './filterReducer'

const combinedReducers = {
  content,
  entities,
  filters,
  preferences,
  environment,
  social,
  // mailinglist,
  form: reduxForm,
  booking,
  reservation,
  calendar,
  compare
}

const reducer = combineReducers(combinedReducers)

export default reducer
